import RegistrationTracker from './RegistrationTracker';
import KarteTracker from '../../lib/KarteTracker';
import YouTubePlayer from './YouTubePlayer';

const track = (step: number, subset?: string) => {
  const tracker = new RegistrationTracker();
  tracker.track(step, { subset });
};

const isVisible = (elem: HTMLElement | null): boolean =>
  elem !== null &&
  !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

document.addEventListener('DOMContentLoaded', () => {
  if (!isVisible(document.querySelector('#personal-orders-completed'))) return;

  track(8);

  const karteTracker = new KarteTracker();
  karteTracker.trackConversion('subscription_reg');

  const $moveToApp = document.querySelectorAll('#move-to-app, #move-to-app-sp');
  const $moveToLearn = document.querySelectorAll(
    '#move-to-learn, #move-to-learn-sp',
  );
  const $moveToTaraLp = document.querySelectorAll(
    '#move-to-tara-lp, #move-to-tara-lp-sp',
  );
  const $moveToSupportWeb = document.querySelector('#move-to-support-web');
  const $moveToParentLp = document.querySelector('#move-to-parent-lp');
  const $moveToAppStore = document.querySelector('#move-to-app-store');
  const $moveToGooglePlay = document.querySelector('#move-to-google-play');
  const $moveToAmazonAppstore = document.querySelector(
    '#move-to-amazon-appstore',
  );
  const $moveToSystemRequirements = document.querySelector(
    '#move-to-system-requirements',
  );
  const $moveToGettingStarted = document.querySelector(
    '#move-to-getting-started',
  );

  $moveToApp.forEach((element) => {
    element.addEventListener('click', () => track(9, 'go_app'));
  });
  $moveToLearn.forEach((element) => {
    element.addEventListener('click', () => track(9, 'go_learn'));
  });
  $moveToTaraLp.forEach((element) => {
    element.addEventListener('click', () => track(9, 'go_tara_lp'));
  });
  $moveToSupportWeb?.addEventListener('click', () => track(9, 'go_support'));
  $moveToParentLp?.addEventListener('click', () => track(9, 'go_parent_lp'));
  $moveToAppStore?.addEventListener('click', () => track(9, 'go_app_ios'));
  $moveToGooglePlay?.addEventListener('click', () =>
    track(9, 'go_app_android'),
  );
  $moveToAmazonAppstore?.addEventListener('click', () =>
    track(9, 'go_app_amazon'),
  );
  $moveToSystemRequirements?.addEventListener('click', () =>
    track(9, 'go_system_requirements'),
  );
  $moveToGettingStarted?.addEventListener('click', () =>
    track(9, 'go_getting_started'),
  );
});

document.addEventListener('DOMContentLoaded', () => {
  if (
    !isVisible(
      document.querySelector('#personal-orders-tara-junior-high-completed'),
    )
  )
    return;

  // ref: https://github.com/quipper/aya-issues/issues/70039
  const onPlay = () => track(9, 'video_play');
  const onEnd = () => track(9, 'video_ended');
  const player = new YouTubePlayer(
    'player-for-tara-junior-high',
    'a6hM9K0m7Y4',
    onPlay,
    onEnd,
  );
  player.begin();
});
